<template>
    <div>
      <PendingOrders></PendingOrders>
    </div>
  </template>
  
  <script>
  const PendingOrders = defineAsyncComponent(() =>
    import("@/components/cases/LabdaqPendingOrders")
  );
  import { defineAsyncComponent } from "vue";
  export default {
    components: {
        PendingOrders,
    },
  };
  </script>
  